<!-- 補助クーポン -->
<template>
  <div class="sp-margin-bottom" ref="target">
    <!-- 補助クーポン PC -->
    <div class="p-menu-subsidy-coupon-list">
      <div class="p-menu-subsidy-coupon-list__title">
        <div class="p-menu-subsidy-coupon-list__title__icon">
          <Icon
            name="contents_ticket"
            width="48px"
            height="48px"
            color="#da291c"
          />
        </div>
        <div>補助クーポン 利用可能</div>
      </div>
      <!-- 補助クーポン一覧 -->
      <div
        class="p-menu-subsidy-coupon-list__list"
        :style="{ height: openHeight + 'px' }"
      >
        <div ref="subsidyCouponList">
          <div
            v-for="(subsidy, index) in sortedSubsidyDataByExpiry"
            :key="index"
            class="p-menu-subsidy-coupon-list__detail"
            ref="subsidyCouponDetail"
          >
            <MenuSubsidyCouponDetail :subsidy="subsidy"/>
          </div>
        </div>
      </div>

      <div
        class="p-menu-subsidy-coupon-list__more"
        :class="{
          'p-menus-subsidy-coupon-list__more--disabled': !isShowToggle
        }"
        v-if="subsidyData.length > 1"
      >
        <a
          href="javascript:;"
          class="c-text-button c-text-button--sm c-text-button--color1 c-text-button--right"
          @click="getHiddenHeight(!isShowSubsidyCouponList)"
        >
          {{
            isShowSubsidyCouponList
              ? "閉じる"
              : "他" + (subsidyData.length - 1) + "種の補助クーポンがあります"
          }}
          <Icon
            :name="isShowSubsidyCouponList ? 'arrow_pull_up' : 'arrow_pull_down'"
            width="33px"
            height="48px"
            :color="$colors.brand.general"
          />
        </a>
      </div>
    </div>

    <!-- 補助クーポン SP -->
    <div
      :id="`p-menu-subsidy-coupon-list-sp${closeId}`"
      class="p-menu-subsidy-coupon-list-sp"
    >
      <div
        v-for="(subsidy, index) in sortedSubsidyDataByExpiry"
        :key="index"
        class="coupon-card"
        :class="{'coupon-not-first-hidden': !isShowToggle}"
      >
        <div class="coupon-header">
          <Icon
            name="contents_ticket"
            width="32px"
            height="32px"
            color="#da291c"
          />
          <p>補助クーポン利用可能</p>
        </div>

        <MenuSubsidyCouponDetail :subsidy="subsidy"/>
      </div>
    </div>

    <!-- もっと見る SP -->
    <a
      :href="`#p-menu-subsidy-coupon-list-sp${closeId}`"
      @click="getHiddenHeight(!isShowSubsidyCouponList); scrollToTarget(isShowSubsidyCouponList);"
      v-if="subsidyData.length > 1"
      class="sp-more-link"
    >
      <Icon
        :name="isShowToggle ? 'arrow_up' : 'arrow_down'"
        style="margin-right: 8px;"
      />
      {{ isShowToggle ? '閉じる' : 'もっと見る' }}
    </a>
  </div>
</template>

<script>
import moment from "moment";
import MenuSubsidyCouponDetail from './SubsidyCoupontDetail.vue';

export default {
  components: {
    MenuSubsidyCouponDetail
  },
  props: {
    subsidyData: {
      type: Array,
      default: () => ([])
    },
    /**
     * 閉じるをタップした際の遷移先id属性。
     * 同一のページに複数の本コンポーネントが存在する場合に、idの重複を避ける
     */
    closeId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isShowSubsidyCouponList: false,
      openHeight: 0,
      isShowToggle: true
    };
  },
  computed: {
    /**
     * 有効期限の近い順に並び替えられたsubsidyData
     * @returns { Array? }
     */
    sortedSubsidyDataByExpiry() {
      if (this.subsidyData == null || this.subsidyData?.length < 1) { return null }

      const cloneSubsidyData = structuredClone(this.subsidyData)
      cloneSubsidyData.sort((prev, next) => {
        const prevFrom = prev.availableData.priceList[0].limApplicableDateFrom
        const nextFrom = next.availableData.priceList[0].limApplicableDateFrom
        return moment(prevFrom).isBefore(nextFrom) ? -1 : 1
      })
      return cloneSubsidyData
    }
  },
  methods: {
    // インフォメーションの表示、非表示高さ取得・調整
    getHiddenHeight: function(flg) {
      this.$nextTick(function() {
        if (typeof flg === "boolean") {
          this.isShowSubsidyCouponList = flg;
        }
        if (!this.$refs.subsidyCouponList) return;

        if (this.isShowSubsidyCouponList) {
          // 表示の場合
          let rectText = this.$refs.subsidyCouponList.getBoundingClientRect();
          this.openHeight = rectText.height;
          this.isShowToggle = true;
        } else {
          // 非表示の場合
          let rectText = this.$refs.subsidyCouponDetail[0].getBoundingClientRect();
          this.openHeight = rectText.height;
          this.isShowToggle = false;
        }
      });
    },

    getMessagePriceCoupon(subsidy) {
      let messagePrice = "";
      if (
        subsidy.availableData.parsonalUsedMaxCnt > 0 &&
        subsidy.availableData.parsonalUsedMaxTotalAmt > 0
      ) {
        messagePrice += `保有枚数 ${this.$filters.formatInteger(subsidy.remainingCount)}/${this.$filters.formatInteger(subsidy.availableData.parsonalUsedMaxCnt)}枚\n`;
        messagePrice += `利用可能残金額 ${this.$filters.formatInteger(subsidy.remainingAmount)}/${this.$filters.formatInteger(subsidy.availableData.parsonalUsedMaxTotalAmt)}円`;
      } else if (
        subsidy.availableData.parsonalUsedMaxCnt > 0 &&
        !subsidy.availableData.parsonalUsedMaxTotalAmt
      ) {
        messagePrice += `保有枚数 ${this.$filters.formatInteger(subsidy.remainingCount)}/${this.$filters.formatInteger(subsidy.availableData.parsonalUsedMaxCnt)}枚`;
      } else if (
        !subsidy.availableData.parsonalUsedMaxCnt &&
        subsidy.availableData.parsonalUsedMaxTotalAmt > 0
      ) {
        messagePrice += `利用可能残金額 ${this.$filters.formatInteger(subsidy.remainingAmount)}/${this.$filters.formatInteger(subsidy.availableData.parsonalUsedMaxTotalAmt)}円`;
      }
      return messagePrice;
    },
    scrollToTarget(flg) {
      if (flg) {
        let targetY = this.$refs.target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: targetY -15
        });
      }
    }
  },
  mounted() {
    this.getHiddenHeight();
    window.addEventListener("resize", this.getHiddenHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getHiddenHeight);
  },
  watch: {
    $route() {
      this.getHiddenHeight();
    },
    menu() {
      this.getHiddenHeight();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './p-menu-subsidy-coupon-list.scss';
.sp-margin-bottom {
  @include mq() {
    margin-bottom: 1rem;
  }
}

.p-menu-subsidy-coupon-list-sp {
  display: none;
  margin-top: .75rem;

  @include mq() {
    display: flex;
    flex-direction: column;
  }

  p {
    margin-bottom: 0;
  }

  .coupon-card {
    width: 100%;
    padding: .75rem;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: .375rem;
    font-size: 12px;
    margin-bottom: .625rem;
    color: #1F2021;

    &.coupon-not-first-hidden:not(:first-child) {
      display: none;
    }

    .coupon-header {
      display: flex;
      align-items: center;
      font-size: .875rem;
      font-weight: bold;
      margin-bottom: .875rem;
      > p {
        margin-left: .625rem;
      }
    }

    .coupon-subsidy-nm {
      font-size: .875rem;
      font-weight: bold;
      margin-bottom: .75rem;
    }

    .mb-8px {
      margin-bottom: .5rem;
    }
  }
}

.sp-more-link {
  width: 100%;
  background-color: white;
  text-align: center;
  padding: .75rem 0;
  border-bottom: 1px solid #CACCCF;
  font-size: .8125rem;
  color: #1F2021;
  cursor: pointer;
  display: none;

  @include mq() {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
